module.exports = __webpack_public_path__ + "img/smarthub-home.3216a48c.svg";